import axios from 'axios';
import type { IJpmcTransaction } from '@/app-package';

const getJpmTransactionInfoKeyholder = async ({
  JPMCUid,
}: {
  JPMCUid: string;
}): Promise<IJpmcTransaction | undefined> => {
  try {
    const { data } = await axios.get<IJpmcTransaction>(
      `/supra/jpm_transaction_info_keyholder/${encodeURIComponent(JPMCUid)}`,
    );
    return data;
  } catch {
    return undefined;
  }
};

export default getJpmTransactionInfoKeyholder;
